import { ApolloClient } from '@apollo/client';

const PAYMENT_AFFECTED_ROOT_FIELDS = [
  'user',
  'clients',
  'activeWorkShift',
  'eventList',
  'getPaymentsByClientId',
  'getWorkShiftPaymentOverviewData',
  'getActiveClientList',
];

const DOMAIN_AFFECTED_ROOT_FIELDS = {
  payments: PAYMENT_AFFECTED_ROOT_FIELDS,
  hosts: [
    'hostsOverview',
    'hostGroupsOverview',
    'hostOverview',
    'activeWorkShift',
    'eventList',
  ],
  bookings: ['getBookings', 'hostsOverview', 'hostGroupsOverview'],
  shop: ['goods', 'services', 'tariffGrid', 'comboList'],
  sessions: [
    'hostsOverview',
    'hostOverview',
    'getActiveClientList',
    'activeWorkShift',
    'eventList',
  ],
  clients: ['user', 'clients', 'getPaymentsByClientId', 'getActiveClientList'],
  logs: ['eventList'],
} as const;

export type SandboxCacheDomain = keyof typeof DOMAIN_AFFECTED_ROOT_FIELDS;

export const refreshSandboxViews = async <TCacheShape extends object>(
  client: ApolloClient<TCacheShape>,
  domains: SandboxCacheDomain[]
): Promise<void> => {
  const fields = new Set<string>();
  domains.forEach((domain) =>
    DOMAIN_AFFECTED_ROOT_FIELDS[domain].forEach((field) => fields.add(field))
  );
  fields.forEach((fieldName) => {
    client.cache.evict({ id: 'ROOT_QUERY', fieldName });
  });
  client.cache.gc();
  await client.refetchQueries({ include: 'active' });
};

export const refreshSandboxPaymentViews = async <TCacheShape extends object>(
  client: ApolloClient<TCacheShape>
): Promise<void> =>
  refreshSandboxViews(client, ['payments', 'shop', 'sessions']);
